import { Action } from "redux";
import { loadAndTrack } from "redux-request-loading";
import { ThunkDispatch } from "redux-thunk";

import { AnsweredQuestionWithId } from "@teamprevent/common/model";
import { SUBMIT_QUESTIONNAIRE, submitQuestionnaireSuccess, saveQuestionnaireSuccess } from "@teamprevent/common/questionnaires/actions";
import { toast } from "@teamprevent/common/toasts";

import { Dispatch } from "../../store";
import { questionnaireKey } from "../../clinicalNotes/components/ClinicalNotes";
import { submitClinicalNotesSuccess } from "../../clinicalNotes/actions";
import { ApplicationState } from "../../applicationState";

import { ClinicalNotesApi } from "./clinicalNotesApi";

export const saveHealthSurveillanceClinicalNotes = (
    customerId: string, ohCaseId: string, taskId: string, questions: AnsweredQuestionWithId[], eTag: string
) => {
    return async (dispatch: ThunkDispatch<ApplicationState, undefined, Action>) => {
        const response = await loadAndTrack(
            dispatch,
            "SaveHealthSurveillanceClinicalNotes",
            ClinicalNotesApi.saveClinicalNotes(customerId, ohCaseId, taskId, questions, eTag)
        );
        dispatch(saveQuestionnaireSuccess({ questionnaireKey, eTag: response.eTag }));
    };
};

export const submitHealthSurveillanceClinicalNotes = (customerId: string, ohCaseId: string, taskId: string) =>
    async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, SUBMIT_QUESTIONNAIRE, ClinicalNotesApi.submitClinicalNotes(customerId, ohCaseId, taskId));
        dispatch(submitQuestionnaireSuccess(questionnaireKey));
        dispatch(submitClinicalNotesSuccess({
            ohCaseId,
            tasks: result
        }));
        toast.success("Clinical Notes submitted successfully");
    };
